import { SystemPrivilegeListItem } from 'types/systemPrivileges';

export const NON_EDITABLE_ROLE_CODES = ['TENANT_ADMIN', 'TENANT_USER'];

const PERMISSION_GROUP_ORDER: Record<string, number> = {
    READ: 1,
    CREATE: 2,
    UPDATE: 3,
    DELETE: 4,
};
const DEFAULT_GROUP_ORDER = 5;

function getPermissionGroupOrder(code: string): number {
    const actionType = code.split('.')[0];
    return PERMISSION_GROUP_ORDER[actionType] ?? DEFAULT_GROUP_ORDER;
}

export function sortPermissionsByGroup(permissions: SystemPrivilegeListItem[]): SystemPrivilegeListItem[] {
    return permissions.toSorted((a, b) => {
        const groupDiff = getPermissionGroupOrder(a.code) - getPermissionGroupOrder(b.code);
        if (groupDiff !== 0) return groupDiff;
        return a.code.localeCompare(b.code);
    });
}
